export default __webpack_public_path__ + "static/media/bat1.9fcfc3da.jpg";